import { usePresencesStore } from '~/stores/PresencesStore'

export default defineNuxtRouteMiddleware(() => {
  console.log('Inside middlleware reset-daily-record');
  const presencesStore = usePresencesStore()

  presencesStore.resetDailyRecordState()
  presencesStore.resetPresencesUiState()
})
